import classNames from "classnames";
import { ReactNode, cloneElement, isValidElement } from "react";

import styles from "./FormInputWrapper.module.css";

const FormInputWrapper: React.FC<
  FormInputWrapperProps & React.HTMLProps<HTMLInputElement | HTMLSelectElement>
> = ({
  className,
  label,
  error,
  help,
  id,
  name,
  required,
  children,
  prefix,
  suffix,
  ...props
}) => {
  const referenceId = id || name;
  return (
    <div
      className={classNames(className, {
        [styles.hasError]: error,
        [styles.hasPrefix]: !!prefix,
        [styles.hasSuffix]: !!suffix,
        [styles.isDisabled]: props.disabled,
      })}
    >
      <div className={styles.prefixSuffixWrapper}>
        {prefix && <div className={styles.prefix}>{prefix}</div>}
        <div className={styles.inputWrapper}>
          {isValidElement(children) &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            cloneElement(children as React.ReactElement<any>, {
              className: classNames(styles.input, children.props.className),
              id: referenceId,
              name: name,
              placeholder: " ",
              "aria-required": required,
              "aria-invalid": !!error,
              "aria-describedby": error && `${referenceId}_help`,
              ...props,
            })}

          <label className={styles.label} htmlFor={referenceId}>
            {required && <span aria-hidden={true}>*</span>} {label}
          </label>
          <fieldset className={styles.fieldset} aria-hidden={true}>
            <legend className={styles.legend}>
              {required && "*"} {label}
            </legend>
          </fieldset>
        </div>
        {suffix && <div className={styles.suffix}>{suffix}</div>}
      </div>
      {help && !error && (
        <p className={styles.help} id={`${referenceId}_help`}>
          {help}
        </p>
      )}
      {error && (
        <p className={styles.error} id={`${referenceId}_help`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormInputWrapper;

export type FormInputWrapperProps = {
  children?: ReactNode;
  label: string;
  name: string;
  error?: string;
  help?: string;
  prefix?: string;
  suffix?: string;
};
